import angular from 'angular';
import { lory } from 'lory.js';
import { min, ceil } from 'lodash';

import {} from './od-lory-carousel.less';

module.exports = angular.module('market.components.od-lory-carousel', [])
.component('odLoryCarousel', {
  bindings: {
    photos: '<',
  },
  template: require('./od-lory-carousel.jade')(),
  controller: class {
    constructor($element, $timeout, $mediaQuery) {
      this.$element = $element;
      this.$timeout = $timeout;
      this.$mediaQuery = $mediaQuery;
      this.currentSlideNum = 1;
      this.totalSlidesNum = 1;
    }

    $postLink() {
      // Note this is to let Angular complete a run loop to render everything before calling Lory
      this.$timeout(() => {
        let numPhotosPerSlide = min([3, this.photos.length]);
        if (!this.$mediaQuery('gt-xs')) {
          numPhotosPerSlide = 1;
        }
        lory(this.$element[0], {
          rewind: true,
          rewindOnResize: false,
          slidesToScroll: numPhotosPerSlide
        });
        this.totalSlidesNum = ceil(this.photos.length / numPhotosPerSlide);

        this.$element[0].addEventListener('after.lory.slide', (event) => {
          this.$timeout(() => {
            this.currentSlideNum = ceil((event.detail.currentSlide + 1) / numPhotosPerSlide);
          });
        });
      });
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-lory-carousel.js
 **/